import { useState } from "react";
import MainCard from "../components/MainCard";
import TotalCard from "../components/TotalCard";
import Layout from "../layouts/layout";
import styles from "../styles/_pages/home.module.scss";

const Home = () => {
  const [visitors, setVisitors] = useState([
    {
      id: 1,
      title: "an adult",
      price: 20,
      amount: 0,
    },
    {
      id: 2,
      title: "children",
      price: 10,
      amount: 0,
    },
    {
      id: 3,
      title: "an adult",
      price: 25,
      amount: 0,
    },
  ]);

  const [cart, setCart] = useState([]);

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1 className={styles.mainHeading}>
            Book a visit to the Ben-Gurion barracks
          </h1>
          <p className={styles.mainText}>
            You are invited to register for the activity. Please note that there
            is no obligation to register and pay on the website, you can pay at
            the cash register. The site does give an idea of ​​the occupancy on
            the site, while there are not many tickets it means that there are
            many groups at that time. Guided visit on Sunday-Thursday at
            12:00-13:30. During the Hanukkah holiday, Tuesday-Thursday and
            Monday, 20-22.12 + 25-26.12, the guided visits will not take place
            at 12:00, instead there will be special guided visits every round
            hour with lanterns to the hut.
          </p>

          <div className={styles.cards}>
            <MainCard
              visitors={visitors}
              setVisitors={setVisitors}
              cart={cart}
              setCart={setCart}
            />
            <MainCard
              visitors={visitors}
              setVisitors={setVisitors}
              cart={cart}
              setCart={setCart}
            />
            <MainCard
              visitors={visitors}
              setVisitors={setVisitors}
              cart={cart}
              setCart={setCart}
            />
          </div>

          <div className={styles.total}>
            <TotalCard
              visitors={visitors}
              setVisitors={setVisitors}
              cart={cart}
              setCart={setCart}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
